exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".green-text[data-v-c8923daa]{color:green!important}", ""]);

// exports
